<template>
  <div
    ref="emojiPickerRef"
    :class="`mt-3 text-left emoji-reaction-container  ${wrapClass}`"
  >
    <div class="emoji-reaction">
      <img
        src="@/assets/img/icons/smile-plus.svg"
        width="24"
        height="24"
        role="button"
        class="mt-1"
        :id="`emoji-button${task.id}${!this.listDisplay ? 't' : ''}${
          this.isReply ? '_reply' : ''
        }`"
        @click="toggleEmojiPicker($event, task.id)"
      />
      <div
        class="emoji-picker"
        :style="popupStyle"
        :id="`emoji-picker${task.id}${!this.listDisplay ? 't' : ''}${
          this.isReply ? '_reply' : ''
        }`"
      >
        <Picker
          v-show="emojiPickerToggled && task.id == emojiPickerToggled"
          :data="emojiIndex"
          :showPreview="false"
          set="google"
          :perLine="8"
          @select="storeEmoji"
        />
      </div>
      <span class="emojis">
        <span
          v-for="(count, emoji) in task.grouped_reactions"
          :key="emoji"
          :class="[myReaction(task.reactions, emoji) ? 'my-reaction' : '']"
        >
          <emoji
            :data="emojiIndex"
            :emoji="emoji"
            :size="23"
            :tooltip="true"
            @click="storeEmoji"
          />
          <span class="count">{{ count }}</span>
        </span>
      </span>
    </div>
    <div class="who-reacted" v-if="task.reactions && task.reactions.length">
      <button
        class="btn btn-link btn-sm p-0 mt-2"
        @click.prevent="showReactedUsersDialog"
      >
        Who Reacted?
      </button>
    </div>
    <modal
      :name="`reacted-users${task.id}${!this.listDisplay ? 't' : ''}${
        this.isReply ? '_reply' : ''
      }`"
      :width="440"
      :focus-trap="false"
      v-model="showReactedUsersModal"
    >
      <div class="reacted-users-container">
        <div class="modal-title border-bottom text-secondary text-center">
          Users Reactions
        </div>
        <div class="content-container border-bottom">
          <div
            class="reacted-user-row"
            v-for="(reaction, index) in task.reactions"
            :key="index"
          >
            <div class="user-image">
              <img
                :src="reaction.user_profile_picture || profileImagePlaceholder"
                :alt="reaction.user_name"
              />
              <span class="emoji-on-image">
                <emoji :data="emojiIndex" :emoji="reaction.emoji" :size="18" />
              </span>
            </div>
            <div class="info-container">
              <span class="text-primary font-weight-bold user-name">{{
                reaction.user_name
              }}</span>
              <span class="text-secondary user-email">{{
                reaction.user_email
              }}</span>
            </div>
            <small class="text-muted created_at">{{
              prettyDate(reaction.created_at)
            }}</small>
          </div>
        </div>
        <div class="text-center py-3">
          <button class="btn btn-outline-blue" @click.prevent="closeModal">
            Close
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import "emoji-mart-vue-fast/css/emoji-mart.css";
import data from "emoji-mart-vue-fast/data/google.json";
import { Emoji, EmojiIndex, Picker } from "emoji-mart-vue-fast/src";
import { mapActions } from "vuex";
dayjs.extend(relativeTime);

let emojiIndex = new EmojiIndex(data, {
  recentLength: 5,
});

export default {
  props: {
    task: Object,
    isReply: Boolean,
    wrapClass: {
      type: String,
      default: "",
    },
    listDisplay: {
      type: Boolean,
      default: false,
    },
    user: Object,
    emojiPickerToggled: {
      type: Number,
      default: null,
    },
  },
  emits: ["selectEmoji"],
  components: {
    Picker,
    Emoji,
  },
  data() {
    return {
      emojiIndex: emojiIndex,
      showReactedUsersModal: false,
      profileImagePlaceholder: require("@/assets/img/avatars/profiles/avatar.jpg"),
      popupStyle: {
        top: "100%",
        left: "20px",
      },
    };
  },
  beforeDestroy() {
    document.removeEventListener("click", this.clickAway);
  },
  mounted() {
    document.addEventListener("click", this.clickAway);
  },
  computed: {
    myReaction: function () {
      return (reactions, emoji) => {
        return reactions.filter(
          (reaction) =>
            reaction.user_id == this.user.id && reaction.emoji == emoji
        )?.[0];
      };
    },
  },
  methods: {
    ...mapActions({
      addReaction: "task/addReaction",
      deleteReaction: "task/deleteReaction",
    }),
    toggleEmojiPicker: function () {
      if (!this.$refs.emojiPickerRef) return;
      const trigger = this.$refs.emojiPickerRef;
      const rect = trigger.getBoundingClientRect();
      let top = rect.bottom;
      if (window.innerHeight - rect.bottom > 420) {
        top = "calc(100% + 5px)";
      } else {
        top = "-422px";
      }
      this.popupStyle = {
        top: top,
        left: this.popupStyle.left,
      };
      this.$emit("togglePicker");
    },
    clickAway: function (e) {
      let elements = document.getElementsByClassName(
        "emoji-reaction-container"
      );
      let flag = false;
      for (const element of elements) {
        if (element.contains(e.target)) {
          flag = true;
          break;
        }
      }
      if (!flag) {
        this.$emit("clickAway");
      }
    },
    storeEmoji: function (emoji) {
      if (!this.isReactionExist(this.task, emoji.colons)) {
        this.updateReactions(this.task, {
          type: "ADD",
          task_id: this.task.id,
          emoji: emoji.colons,
          user_id: this.user.id,
          user_name: `${this.user.last}, ${this.user.first}`,
          user_email: this.user.email,
          user_profile_picture: this.user.profile_picture,
          created_at: new Date(),
        });
        this.addReaction({
          task_id: this.isReply ? this.task.task_id : this.task.id,
          emoji: emoji.colons,
          isReply: this.isReply,
          reply_id: this.task.id,
        });
      } else {
        this.updateReactions(this.task, {
          type: "DELETE",
          emoji: emoji.colons,
          user_id: this.user.id,
        });
        this.deleteReaction({
          task_id: this.isReply ? this.task.task_id : this.task.id,
          emoji: emoji.colons,
          isReply: this.isReply,
          reply_id: this.task.id,
        });
      }
      this.$emit("selectEmoji", emoji, this.task);
    },
    updateReactions: function (task, obj) {
      if (obj.type == "ADD") {
        task.reactions.push(obj);
        if (obj.emoji in task.grouped_reactions) {
          task.grouped_reactions[obj.emoji]++;
        } else {
          task.grouped_reactions[obj.emoji] = 1;
        }
      }
      if (obj.type == "DELETE") {
        const reactionIndex = task.reactions.findIndex(
          (item) => item.user_id == obj.user_id && item.emoji == obj.emoji
        );
        if (reactionIndex >= 0) {
          task.reactions.splice(reactionIndex, 1);
          if (task.grouped_reactions[obj.emoji] - 1 > 0) {
            task.grouped_reactions[obj.emoji]--;
          } else {
            delete task.grouped_reactions[obj.emoji];
          }
        }
      }
    },
    isReactionExist: function (task, emoji) {
      const userId = this.user.id;
      const reaction = task.reactions.filter(
        (reaction) => reaction.emoji == emoji && reaction.user_id == userId
      )?.[0];
      return reaction ? true : false;
    },
    showReactedUsersDialog: function () {
      this.showReactedUsersModal = true;
    },
    closeModal: function () {
      this.showReactedUsersModal = false;
    },
    prettyDate: function (date) {
      return dayjs(date).fromNow();
    },
  },
};
</script>
<style lang="scss" scoped>
.emoji-reaction-container {
  .emoji-reaction {
    display: flex;
    position: relative;
    width: fit-content;
    justify-content: center;
    align-items: flex-start;
    gap: 5px;
    .emoji-picker {
      position: absolute;
      z-index: 99;

      @media (max-width: 767px) {
        left: -16px !important;
      }
    }
    img {
      transition: transform 0.2s ease-in-out;
    }
    img:hover {
      transform: scale(1.1);
    }
    .my-reaction {
      background-color: #5187ec1f !important;
      border-color: #5186ec !important;
    }
    .emojis {
      display: flex;
      flex-wrap: wrap;
      gap: 5px;
      margin-right: 1rem;
      cursor: pointer;
      > span {
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #eee;
        border: 1px solid transparent;

        border-radius: 15px;
        padding: 2px 5px;
        transition: all 0.1s ease-in-out;
        > span {
          padding: 0;
        }
        &:hover {
          border: 1px solid #bfb9b9;
          background-color: #f1f1f1;
        }
        .count {
          font-size: 13px;
          font-weight: bold;
          padding: 0px 3px 0px 2px;
        }
      }
    }
  }
}

.reacted-users-container {
  display: flex;
  flex-direction: column;
  min-height: 0;
  max-height: calc(100vh - 4rem);

  .modal-title {
    flex: 0 0 auto;
    padding: 14px 16px;
    font-size: 20px;
  }

  .content-container {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 8px 0;
  }

  .reacted-user-row {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 16px;

    &:hover {
      background-color: rgba(81, 135, 236, 0.06);
    }
  }

  .user-image {
    position: relative;
    flex: 0 0 auto;
    line-height: 0;

    img {
      display: block;
      object-fit: cover;
      border-radius: 100%;
      height: 44px;
      width: 44px;
    }

    .emoji-on-image {
      position: absolute;
      bottom: -4px;
      right: -4px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 22px;
      height: 22px;
      border-radius: 100%;
      background-color: var(--body-bg-color, #fff);
      box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08);
    }
  }

  .info-container {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-width: 0;

    .user-name,
    .user-email {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .user-email {
      font-size: 13px;
    }
  }

  .created_at {
    flex: 0 0 auto;
    white-space: nowrap;
    font-size: 12px;
  }
}
</style>
